export const GET_PAYMENT_REMINDER = "GET_PAYMENT_REMINDER";
export const GET_PAYMENT_REMINDER_SUCCESS = "GET_PAYMENT_REMINDER_SUCCESS";
export const GET_PAYMENT_REMINDER_ERROR = "GET_PAYMENT_REMINDER_ERROR";
export const DELETE_PAYMENT_REMINDER = "DELETE_PAYMENT_REMINDER";
export const DELETE_PAYMENT_REMINDER_SUCCESS = "DELETE_PAYMENT_REMINDER_SUCCESS";
export const DELETE_PAYMENT_REMINDER_ERROR = "DELETE_PAYMENT_REMINDER_ERROR";
export const UPDATE_PAYMENT_REMINDER = "UPDATE_PAYMENT_REMINDER";
export const UPDATE_PAYMENT_REMINDER_SUCCESS = "UPDATE_PAYMENT_REMINDER_SUCCESS";
export const UPDATE_PAYMENT_REMINDER_ERROR = "UPDATE_PAYMENT_REMINDER_ERROR";
export const TOOGLE_PAYMENT_REMINDER = "TOOGLE_PAYMENT_REMINDER";
export const TOOGLE_PAYMENT_REMINDER_SUCCESS = "TOOGLE_PAYMENT_REMINDER_SUCCESS";
export const TOOGLE_PAYMENT_REMINDER_ERROR = "TOOGLE_PAYMENT_REMINDER_ERROR";


export const getPaymentReminder = () => {
    return{
      type: GET_PAYMENT_REMINDER,
    }
  };

  export const getPaymentReminderSuccess = (getPaymentReminderSucces) => ({
    type: GET_PAYMENT_REMINDER_SUCCESS,
    getPaymentReminderSucces
  });
  
  export const getPaymentReminderError = (err) => ({
    type: GET_PAYMENT_REMINDER_ERROR,
    getPaymentReminderError: err,
  });

  export const updatePaymentReminder = (action) => {
    return{
      type: UPDATE_PAYMENT_REMINDER,
      action
    }
  };

  export const updatePaymentReminderSucess = (updatePaymentReminderSucces) => ({
    type: UPDATE_PAYMENT_REMINDER_SUCCESS,
    updatePaymentReminderSucces
  });
  
  export const updatePaymentReminderError = (err) => ({
    type: UPDATE_PAYMENT_REMINDER_ERROR,
    updatePaymentReminderError: err,
  });

  export const togglePaymentReminder = (action) => {
    return{
      type: TOOGLE_PAYMENT_REMINDER,
      action
    }
  };

  export const togglePaymentReminderSucess = (togglePaymentReminderSucces) => ({
    type: TOOGLE_PAYMENT_REMINDER_SUCCESS,
    togglePaymentReminderSucces
  });
  
  export const togglePaymentReminderError = (err) => ({
    type: TOOGLE_PAYMENT_REMINDER_ERROR,
    togglePaymentReminderError: err,
  });

  export const deletePaymentReminder = (idReminder) => {
    return{
      type: DELETE_PAYMENT_REMINDER,
      idReminder
    }
  };

  export const deletePaymentReminderSucess = (deletePaymentReminderSucces) => ({
    type: DELETE_PAYMENT_REMINDER_SUCCESS,
    deletePaymentReminderSucces
  });
  
  export const deletePaymentReminderError = (err) => ({
    type: DELETE_PAYMENT_REMINDER_ERROR,
    deletePaymentReminderError: err,
  });